import jwt_decode from 'jwt-decode';

export type TJwtConcierge = {
  conciergeId: number;
  name: string;
  role: number;
};
type TJwt = {
  concierge: TJwtConcierge;
  iat: number;
  exp: number;
};
export const decode = (jwt: string): TJwtConcierge => {
  const decode = <TJwt>jwt_decode(jwt);
  return decode.concierge;
};
